export const SET_HISTORIAL_MATRICULAS = 'SET_HISTORIAL_MATRICULAS';
export const SET_MATRICULA_DETALLE = 'SET_MATRICULA_DETALLE';
